import { FC } from "react"
import { Outlet } from "react-router-dom";
import { CommonHeader } from "../parts/CommonHeader";
import { isHeritageClause } from "typescript";
import { CommonFooter } from "../parts/CommonFooter";

export const MainLayout: FC = () => {
  return  <>
    <div className="">
      <CommonHeader />
      <div className="w-full">
        <Outlet />
      </div>
      <CommonFooter />
    </div>
  </>
}